import {t} from '../../../common/getTranslations';
import {getPeriodText} from '../../../common/shared/utils/getPeriodText';
import {twMerge} from '../../../common/twMerge';
import {CONTENT_HOME_WAITFREE_BADGE_TYPE_MAP} from '../../../domain/content/[seriesId]/constant';
import {getContentHomeWaitfreeBadgeType} from '../../../domain/content/[seriesId]/util/getContentHomeWaitfreeBadgeType';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {ViewerEndWaitfreeDescriptionProps} from './ViewerEndWaitfreeDescriptionProps.interface';

export function ViewerEndWaitfreeDescription({
  isMobile,
  waitfreePeriodByMinute,
  isPageViewer,
}: ViewerEndWaitfreeDescriptionProps) {
  const currentWaitfreeBadgeType = getContentHomeWaitfreeBadgeType(
    waitfreePeriodByMinute
  );
  return (
    <div
      className={twMerge(
        'bg-theme-bg-surface-alt',
        !isMobile && 'pb-16pxr',
        !isMobile && isPageViewer && 'px-32pxr'
      )}
    >
      <div
        className={twMerge(
          'flex items-center bg-theme-solid-20',
          isMobile ? 'h-56pxr justify-center' : 'h-48pxr',
          !isMobile &&
            isPageViewer &&
            'rounded-[3px] border border-solid border-static-transparent-black-05'
        )}
      >
        {currentWaitfreeBadgeType && (
          <Icon
            type={
              CONTENT_HOME_WAITFREE_BADGE_TYPE_MAP[currentWaitfreeBadgeType] ||
              IconType.ContentHomeTimeStatic
            }
            disableActiveEffect
            className={twMerge('mr-6pxr', !isMobile && 'ml-20pxr mr-10pxr')}
          />
        )}
        <Text className="font-small1 text-theme-solid-100">
          {t('viewer_end_wuf_period_info', {
            values: {
              value: getPeriodText(waitfreePeriodByMinute),
            },
          })}
        </Text>
      </div>
    </div>
  );
}
